export default __webpack_public_path__ + "static/media/navigate.11dfd3d9.svg";